import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH ACTIVITIES OF PRODUCT- TABLE DATA ********************
export const fetchActivitiesProduct = (options) => async (
	dispatch,
	getState
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ACTIVITIES_PRODUCT_LOADING,
			payload: true
		});

		const {
			activity_product: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					},
					product: { uuid, type }
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		let url = `/activity/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		if (uuid && type) {
			url += `&model_id=${uuid}&model_type=${type}`;
		}

		const { data } = await services.get(url);

		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ACTIVITIES_PRODUCT_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_ACTIVITIES_PRODUCT_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setActivityProductQuery = (query) => ({
	type: types.SET_ACTIVITY_PRODUCT_SEARCH_QUERY,
	payload: query
});

export const setActivityProduct = (uuid, type) => ({
	type: types.SET_ACTIVITY_PRODUCT,
	payload: { uuid, type }
});
